/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-10 11:44:20
 * @LastEditors: K
 * @LastEditTime: 2022-08-18 09:48:09
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Row, Table } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { EditableColumnType } from '../../../../compnents/list/EditableList'

import { NavBar } from '../../../../compnents/nav/NavBar'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { Columns } from './Columuns'
import { Query } from './Query'
import styles from './order.module.css'
import { useLocation } from 'react-router-dom'
import { getReplaceMakeOrderDetail } from '../../StatisticSlice'
import { getSexName, headerDataType } from '../../../../models/StatisticAnalysis'

// 代煎订单详情
export const ReplaceMakeOrderDetail = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const location: any = useLocation()

  const dispatch = useDispatch<RootDispatch>()

  const [data, setData] = useState<any>([])

  const [headerData, setHeaderData] = useState<headerDataType>()

  const columns: EditableColumnType<Record<string, any>>[] = [
    {
      title: `序号`,
      key: 'no',
      align: 'center',
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: '药品名称',
      dataIndex: 'medicineName',
      key: 'medicineName',
      align: 'center',
      render: function medicineName(_, t) {
        return (
          <div>
            <span>{t.medicineName} </span> <span style={{ color: '#999' }}>{t.accountUnit}</span>
          </div>
        )
      }
    },
    {
      title: '贴数',
      dataIndex: 'tip',
      key: 'tip',
      align: 'center',
    },
    {
      title: '每贴数量',
      dataIndex: 'countPerTip',
      key: 'countPerTip',
      align: 'center',
    },

    {
      title: '总数量',
      dataIndex: 'drugCount',
      key: 'drugCount',
      align: 'center',
    },
    {
      title: '用法',
      key: 'normalUsemethod',
      dataIndex: 'normalUsemethod',
      align: 'center',
      render: (_, r) => r.normalUsemethod || '无',
    },
  ]

  useEffect(() => {

    dispatch(
      getReplaceMakeOrderDetail({
        id: location?.state?.id
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        console.log(777, res);
        setData(res.resList)
        setHeaderData({
          orderNum: res.orderNum,
          uploadTime: res.uploadTime,
          hospitalName: res.hospitalName,
          recipientName: res.recipientName,
          sex: getSexName(res.sex),
          age: res.age,
          recipientPhone: res.recipientPhone,
          addressType: res.addressType === 0 ? '患者地址' : '诊所自取',
          boilTypeName: res.boilTypeName,
          province: res.province + res.city + res.region + res.recipientAddress,
        })
        // setTotal(res.total)
      })
  }, [])

  return (
    <Col
      style={{
        height: 'calc(100% - 20px) ',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <NavBar
        style={{ margin: '10px 0 0 20px' }}
        where={['代煎订单', '订单详情']}
        backtrace={{
          name: '代煎订单',
          path: '/admin/replaceMakeCenter/statisticAnalysis',
          routeName: '代煎订单',
          state: {
            current: location?.state?.current,
          },
        }}
      />
      <Col
        style={{
          flex: 1,
          overflow: 'auto',
          backgroundColor: theme.pn,
          margin: '10px 20px',
          borderRadius: 10,
          padding: '20px 35px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <section>
          <Row className={styles.detail}>
            <Col span={8}>订单编号：{headerData?.orderNum}</Col>
            <Col span={8}>上传时间：{headerData?.uploadTime}</Col>
            <Col span={8}>机构名称：{headerData?.hospitalName}</Col>
          </Row>
          <Row className={styles.detail}>
            <Col span={8}>患者姓名：{headerData?.recipientName}</Col>
            <Col span={8}>患者性别：{headerData?.sex}</Col>
            <Col span={8}>年龄：{headerData?.age}</Col>
          </Row>
          <Row className={styles.detail}>
            <Col span={8}>联系电话：{headerData?.recipientPhone}</Col>
            <Col span={8}>收货位置：{headerData?.addressType}</Col>
            <Col span={8}>加工方式：{headerData?.boilTypeName}</Col>
          </Row>
          <Row>
            <Col span={24}>收货地址：{headerData?.province}</Col>
          </Row>
        </section>
        <Table
          dataSource={data}
          style={{ color: theme.tc3, padding: '0 20px', marginTop: 35 }}
          className={styles.table}
          columns={columns}
          key={'replceMakeOrderDetail'}
          pagination={false}
          bordered
        />
      </Col>
    </Col>
  )
}
